import { IFilterSet, TAllFilter } from 'shared/types/filters';
import { isAvailableStrict, FDealType, FOfferType } from '../../../../../../../packages/JsonQuery';

const OFFER_TYPE = FOfferType.FlatNew;

export const NEWBUILDING_FILTERS_SET: IFilterSet<TAllFilter>[] = [
  {
    availability: isAvailableStrict(FDealType.Sale, OFFER_TYPE),
    list: [
      'dealType',
      'objectType',
      'roomType',
      'price',
      'withNeighbors',
      'completionYear',
      'undergroundTime',
      'offerType',
      'squareMeterArea',
      'layout',
      'ceilingHeight',
      'floor',
      'floors',
      'mortgagePromoSearchType',
      'discountPromoSearchType',
      'constructionType',
      'decorationsList',
      'saleType',
      'apartments',
      'electronicTrading',
      'publicationDate',
      'containWords',
      'excludeWords',
      'contact',
      'offerId',
    ],
  },
];
